<div
  class="evs-card simple-card margin-bottom-0 padding-25"
  (click)="handleClick()">
  {{title}}
</div>
